export const ADD_TRIGGER = 'ADD_TRIGGER';
export const SKIP_TRIGGER = 'SKIP_TRIGGER';
export const CHECK_TRIGGER = 'CHECK_TRIGGER';

export const addTrigger = trigger => ({
    type: ADD_TRIGGER,
    payload: trigger
});

export const skipTrigger = () => ({
    type: SKIP_TRIGGER
});

export const checkTrigger = result => ({
    type: CHECK_TRIGGER,
    payload: result
});
